import { handleActions } from 'redux-actions';
import {
  key,
  authLogin,
  authLogout,
  authLoginSuccess,
  authLogoutSuccess,
  authLoginError,
  authLogoutError,
  authRefreshSession
} from './actions';

export const selectors = {
  status: state => state[key].status,
  user: state => state[key].user
};

const initialState = {
  status: 'unauthenticated',
  user: null
};

export default handleActions({
    [authLogin]: (state, action) => ({
      ...state,
      status: 'performing login'
    }),
    [authLogout]: (state, action) => ({
      ...state,
      status: 'performing logout'
    }),
    [authRefreshSession]: (state, action) => ({
      ...state,
      status: 'refresh session'
    }),
    [authLoginSuccess]: (state, action) => ({
      ...state,
      status: 'authenticated',
      user: action.payload.user
    }),
    [authLogoutSuccess]: (state, action) => ({
      ...state,
      status: 'unauthenticated',
      user: null
    }),
    [authLoginError]: (state, action) => ({
      ...state,
      status: action.payload.err,
      user: null
    }),
    [authLogoutError]: (state, action) => ({
      ...state,
      status: action.payload.err
    }),
  },
  initialState
)
;



// WEBPACK FOOTER //
// ./src/util/redux/auth/reducer.js